import { render, staticRenderFns } from "./inpBox.vue?vue&type=template&id=b173e410&scoped=true&"
import script from "./inpBox.vue?vue&type=script&lang=js&"
export * from "./inpBox.vue?vue&type=script&lang=js&"
import style0 from "./inpBox.vue?vue&type=style&index=0&id=b173e410&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b173e410",
  null
  
)

export default component.exports